export default __webpack_public_path__ + "static/kin_ro_zone-f76c1ab730e6babb3789407c8c57f9cb.png";